import { createContext, useContext, useMemo, useReducer } from "react";
import { LessonStyle } from "../DAL/API";

export enum TopPageOperation {
  SELECT_DATE,
  IDLE,
  SORT_SCHEDULE
}

export type TopPageState = {
  selectedDate: Date | null;
  sortedLessonType: LessonStyle;
};

export type TopPageAction =
  | {
      type: TopPageOperation.SELECT_DATE;
      payload: Date;
    }
  | {
      type: TopPageOperation.SORT_SCHEDULE;
      payload: LessonStyle;
    };

export const TopPageContext = createContext(
  {} as {
    topPageState: TopPageState;
    topPageDispatch: React.Dispatch<TopPageAction>;
  }
);

type Props = {
  children?: React.ReactNode;
};

const reducer = (state: TopPageState, action: TopPageAction) => {
  switch (action.type) {
    case TopPageOperation.SELECT_DATE:
      ;
      return { ...state, selectedDate: new Date(action.payload.getTime()) };
    case TopPageOperation.SORT_SCHEDULE:
      return { ...state, sortedLessonType: action.payload};
    default:
      ;
      return state;
  }
};

export const TopPageContextProvider: React.FunctionComponent<Props> = (
  props
) => {
  const [topPageState, topPageDispatch] = useReducer(reducer, {
    selectedDate: new Date(),
    sortedLessonType: LessonStyle.STUDIO,
  });
  const value = useMemo(
    () => ({ topPageState, topPageDispatch }),
    [topPageState]
  );
  return <TopPageContext.Provider value={value} {...props} />;
};

export const useTopPageContext = () => {
  const context = useContext(TopPageContext);
  if (typeof context === "undefined") {
    throw new Error(
      "useTopPageContext must be within a TopPageContextProvider"
    );
  }
  return context;
};

export default TopPageContextProvider;
